/* KeepHer theme behaviour.
   Campaign countdown + entry popup. The banner markup is only rendered by
   Liquid while the campaign window is open, so this never runs on a stale
   campaign. */
(function () {
  "use strict";

  var root = document.querySelector("[data-campaign]");
  if (!root) { return; }

  var endsAttr = root.getAttribute("data-ends");
  var end = endsAttr ? Date.parse(endsAttr) : NaN;
  var timers = root.querySelectorAll("[data-countdown]");

  function pad(n) { return n < 10 ? "0" + n : "" + n; }

  function tick() {
    if (isNaN(end)) { return; }
    var left = end - Date.now();
    if (left < 0) { left = 0; }
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    var text = "Ends in " + (d > 0 ? d + "d " : "") + pad(h) + "h " + pad(m) + "m " + pad(s) + "s";
    for (var i = 0; i < timers.length; i++) { timers[i].textContent = text; }
  }

  if (timers.length && !isNaN(end)) {
    tick();
    window.setInterval(tick, 1000);
  }

  var modal = root.querySelector("[data-modal]");
  if (!modal || !root.getAttribute("data-popup")) { return; }

  var KEY = "kh_campaign_" + (endsAttr || "x");

  function close() {
    modal.hidden = true;
    document.body.style.overflow = "";
  }

  function open() {
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    var btn = modal.querySelector("[data-modal-close]");
    if (btn) { btn.focus(); }
  }

  var seen = false;
  try { seen = sessionStorage.getItem(KEY) === "1"; } catch (e) { seen = false; }

  if (!seen) {
    window.setTimeout(function () {
      open();
      try { sessionStorage.setItem(KEY, "1"); } catch (e) {}
    }, 1200);
  }

  modal.addEventListener("click", function (e) {
    if (e.target === modal || (e.target.closest && e.target.closest("[data-modal-close]"))) { close(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.hidden) { close(); }
  });
})();

/* ---- variant picker ---------------------------------------------- */
(function () {
  "use strict";
  var form = document.getElementById("ProductForm");
  if (!form) { return; }

  var dataEl = form.querySelector("[data-variant-data]");
  var input = form.querySelector("[data-variant-input]");
  var selectors = form.querySelectorAll("[data-option-selector]");
  if (!dataEl || !input || !selectors.length) { return; }

  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function sync() {
    // Selectors are radios now: one checked input per option index.
    var chosen = [];
    for (var i = 0; i < selectors.length; i++) {
      var el = selectors[i];
      if (el.type === "radio" && !el.checked) { continue; }
      chosen[parseInt(el.getAttribute("data-option-index"), 10) || 0] = el.value;
    }

    for (var v = 0; v < variants.length; v++) {
      var opts = variants[v].options || [];
      var match = true;
      for (var o = 0; o < chosen.length; o++) {
        if (opts[o] !== chosen[o]) { match = false; break; }
      }
      if (match) {
        input.value = variants[v].id;
        var btn = form.querySelector("button[type=submit]");
        if (btn) {
          btn.disabled = !variants[v].available;
          btn.textContent = variants[v].available ? "Add to cart" : "Sold out";
        }
        return;
      }
    }
  }

  for (var i = 0; i < selectors.length; i++) {
    selectors[i].addEventListener("change", sync);
  }
  sync();
})();

/* ---- personalisation --------------------------------------------- */
(function () {
  "use strict";
  var form = document.getElementById("ProductForm");
  if (!form) { return; }

  var box = form.querySelector("[data-personalise]");
  if (!box) { return; }

  // Only reveal the option when JS is available, since charging the add-on
  // depends on the AJAX path below.
  box.hidden = false;

  var toggle = box.querySelector("[data-personalise-toggle]");
  var fields = box.querySelector("[data-personalise-fields]");
  var addonId = box.getAttribute("data-addon");

  var required = fields.querySelector("[data-personalise-required]");

  function syncFields() {
    fields.hidden = !toggle.checked;
    // Required only while the fieldset is visible: a required input inside a
    // hidden container cannot be focused, so the browser would block submit
    // with no visible reason.
    if (required) {
      if (toggle.checked) {
        required.setAttribute("required", "required");
      } else {
        required.removeAttribute("required");
        required.value = "";
      }
    }
  }

  toggle.addEventListener("change", syncFields);
  syncFields();

})();

/* ---- glove stage -------------------------------------------------- */
(function () {
  "use strict";
  var stage = document.querySelector("[data-stage]");
  if (!stage) { return; }

  var chapters = Array.prototype.slice.call(stage.querySelectorAll(".chapter"));
  var N = chapters.length;
  if (N < 2) { return; }

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  var raf = null;

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function frame() {
    raf = null;
    var travel = stage.offsetHeight - window.innerHeight;
    if (travel <= 0) { return; }
    var p = clamp(-stage.getBoundingClientRect().top / travel, 0, 1);
    var pos = p * N;

    for (var i = 0; i < N; i++) {
      var d = pos - (i + 0.5);
      var vis = clamp(1 - Math.abs(d) / 0.8, 0, 1);
      var ch = chapters[i];
      ch.style.opacity = vis;
      ch.inert = vis <= 0.55;

      var art = ch.querySelector(".chapter__art img");
      if (art) {
        art.style.transform =
          "translate3d(0," + (d * -5).toFixed(2) + "vh,0)" +
          " rotate(" + (d * 30).toFixed(2) + "deg)" +
          " scale(" + (0.84 + vis * 0.2).toFixed(3) + ")";
      }
      var copy = ch.querySelector(".chapter__copy");
      if (copy) { copy.style.transform = "translate3d(0," + (d * 24).toFixed(1) + "px,0)"; }
    }
  }

  function onScroll() {
    if (raf === null) { raf = window.requestAnimationFrame(frame); }
  }

  function measure() {
    stage.style.setProperty("--stage-h", (N * 105) + "vh");
    onScroll();
  }

  function enable() {
    document.body.classList.add("motion");
    measure();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", measure);
  }

  function disable() {
    document.body.classList.remove("motion");
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", measure);
    stage.style.removeProperty("--stage-h");
    for (var i = 0; i < N; i++) {
      chapters[i].style.opacity = "";
      chapters[i].inert = false;
      var art = chapters[i].querySelector(".chapter__art img");
      if (art) { art.style.transform = ""; }
      var copy = chapters[i].querySelector(".chapter__copy");
      if (copy) { copy.style.transform = ""; }
    }
  }

  function sync() { reduced.matches ? disable() : enable(); }

  if (reduced.addEventListener) { reduced.addEventListener("change", sync); }
  sync();
})();

/* ---- mobile nav drawer ------------------------------------------- */
(function () {
  "use strict";
  var toggle = document.querySelector("[data-nav-toggle]");
  var drawer = document.querySelector("[data-nav-drawer]");
  if (!toggle || !drawer) { return; }

  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    toggle.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    var close = drawer.querySelector("[data-nav-close]");
    if (close) { close.focus(); }
  }

  function close() {
    drawer.hidden = true;
    toggle.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  toggle.addEventListener("click", function () {
    drawer.hidden ? open() : close();
  });

  drawer.addEventListener("click", function (e) {
    if (e.target === drawer || (e.target.closest && e.target.closest("[data-nav-close]"))) { close(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !drawer.hidden) { close(); }
  });

  // A resize past the desktop breakpoint should not leave the drawer stuck open.
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 900 && !drawer.hidden) { close(); }
  });
})();

/* ---- hero parallax ------------------------------------------------ */
(function () {
  "use strict";
  var hero = document.querySelector(".hero");
  var art = hero && hero.querySelector(".hero__art img");
  if (!art) { return; }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { return; }

  var raf = null;

  function frame() {
    raf = null;
    var vh = window.innerHeight || 1;
    var p = -hero.getBoundingClientRect().top / vh;
    if (p < 0) { p = 0; } else if (p > 1) { p = 1; }
    art.style.setProperty("--par", (p * -54).toFixed(1) + "px");
    art.style.setProperty("--par-scale", (1 + p * 0.025).toFixed(3));
  }

  function onScroll() {
    if (raf === null) { raf = window.requestAnimationFrame(frame); }
  }

  frame();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
})();

/* ---- product recommendations -------------------------------------- */
(function () {
  "use strict";
  var el = document.querySelector("[data-related]");
  if (!el) { return; }
  var url = el.getAttribute("data-url");
  if (!url) { return; }

  fetch(url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.querySelector("[data-related]");
      if (fresh) { el.innerHTML = fresh.innerHTML; }
    })
    .catch(function () { /* recommendations are a bonus, never a blocker */ });
})();

/* ---- cart drawer --------------------------------------------------
   Owns every add-to-cart on the page. Falls back to a normal form POST
   if anything goes wrong, so a network blip never loses a sale.       */
(function () {
  "use strict";
  var drawer = document.getElementById("CartDrawer");
  if (!drawer) { return; }

  var lastFocus = null;

  function panel() { return drawer.querySelector(".cart-drawer__panel"); }

  function syncCount() {
    var n = drawer.getAttribute("data-cart-count");
    var badge = document.querySelector(".cart-link__count");
    if (badge && n !== null) { badge.textContent = n; }
  }

  function refresh() {
    return fetch(window.Shopify && window.Shopify.routes ? "/?section_id=cart-drawer" : "/?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, "text/html").getElementById("CartDrawer");
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          drawer.setAttribute("data-cart-count", fresh.getAttribute("data-cart-count") || "0");
          syncCount();
        }
      });
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
    var close = drawer.querySelector("[data-cart-close]");
    if (close) { close.focus(); }
  }

  function close() {
    drawer.hidden = true;
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  // Cart link opens the drawer rather than navigating.
  document.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest(".cart-link, .nav-drawer__cart");
    if (link) {
      e.preventDefault();
      refresh().then(open).catch(function () { window.location.href = "/cart"; });
      return;
    }
    if (e.target.closest && e.target.closest("[data-cart-close]")) { close(); return; }
    if (e.target === drawer) { close(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !drawer.hidden) { close(); }
  });

  // Quantity and remove.
  function change(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  drawer.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-cart-qty]");
    if (!btn) { return; }

    var key = btn.getAttribute("data-key");
    var to = Number(btn.getAttribute("data-to"));
    var p = panel();
    if (p) { p.setAttribute("aria-busy", "true"); }

    // Removing a personalised glove should take its paid add-on with it,
    // otherwise the customer is left paying $15 for nothing.
    var li = btn.closest("li");
    var wasPersonalised = li && li.hasAttribute("data-personalised");
    var addonKey = drawer.getAttribute("data-addon-key");
    var addonQty = Number(drawer.getAttribute("data-addon-qty") || 0);
    var dropAddon = to === 0 && wasPersonalised && addonKey && addonQty > 0;

    change(key, to)
      .then(function () {
        if (!dropAddon) { return null; }
        return change(addonKey, addonQty - 1);
      })
      .then(refresh)
      .catch(function () { window.location.href = "/cart"; });
  });

  // Add to cart, with personalisation when it is offered and ticked.
  var form = document.getElementById("ProductForm");
  if (form) {
    form.addEventListener("submit", function (e) {
      var variantInput = form.querySelector("[data-variant-input]");
      if (!variantInput) { return; }

      var items = [{ id: Number(variantInput.value), quantity: 1 }];

      var box = form.querySelector("[data-personalise]");
      var toggle = box && box.querySelector("[data-personalise-toggle]");
      if (box && toggle && toggle.checked) {
        var props = {};
        var inputs = box.querySelectorAll("[name^='properties']");
        for (var i = 0; i < inputs.length; i++) {
          if (!inputs[i].value) { continue; }
          props[inputs[i].name.replace("properties[", "").replace("]", "")] = inputs[i].value;
        }
        items[0].properties = props;
        var addonId = box.getAttribute("data-addon");
        if (addonId) { items.push({ id: Number(addonId), quantity: 1 }); }
      }

      e.preventDefault();
      var btn = form.querySelector("button[type=submit]");
      if (btn) { btn.disabled = true; }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) { throw new Error("add failed"); }
        return refresh();
      }).then(function () {
        if (btn) { btn.disabled = false; }
        open();
      }).catch(function () {
        if (btn) { btn.disabled = false; }
        form.submit();
      });
    });
  }

  syncCount();
})();

/* ---- predictive search --------------------------------------------
   The overlay wraps a real search form, so Enter runs a normal search
   and everything below is an enhancement rather than a dependency.   */
(function () {
  "use strict";
  var overlay = document.querySelector("[data-search-overlay]");
  var openBtn = document.querySelector("[data-search-open]");
  if (!overlay || !openBtn) { return; }

  var input = overlay.querySelector("[data-search-input]");
  var results = overlay.querySelector("[data-search-results]");
  var lastFocus = null;
  var timer = null;
  var seq = 0;

  function open() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.body.style.overflow = "hidden";
    if (input) { input.focus(); }
  }

  function close() {
    overlay.hidden = true;
    document.body.style.overflow = "";
    if (results) { results.innerHTML = ""; }
    if (input) { input.value = ""; }
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function search(term) {
    var mine = ++seq;
    var url = "/search/suggest?q=" + encodeURIComponent(term) +
              "&resources[type]=product&resources[limit]=6&section_id=predictive-search";

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // A slower earlier request must never overwrite a newer one.
        if (mine !== seq) { return; }
        var fresh = new DOMParser().parseFromString(html, "text/html")
          .querySelector("[data-predictive-results]");
        if (fresh && results) { results.innerHTML = fresh.innerHTML; }
      })
      .catch(function () { /* Enter still runs a full search */ });
  }

  openBtn.addEventListener("click", open);

  overlay.addEventListener("click", function (e) {
    if (e.target === overlay || (e.target.closest && e.target.closest("[data-search-close]"))) { close(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !overlay.hidden) { close(); }
  });

  if (input) {
    input.addEventListener("input", function () {
      var term = input.value.trim();
      window.clearTimeout(timer);
      if (term.length < 2) {
        seq++;
        if (results) { results.innerHTML = ""; }
        return;
      }
      timer = window.setTimeout(function () { search(term); }, 250);
    });
  }
})();

/* ------------------------------------------------------------------
   Product gallery dots.
   The strip is a plain scroll-snap container, so swiping works with no
   JS at all — this only keeps the dots honest and lets you tap one.
   ------------------------------------------------------------------ */
(function () {
  var gallery = document.querySelector("[data-gallery]");
  if (!gallery) { return; }

  var track = gallery.querySelector("[data-gallery-track]");
  var dots = [].slice.call(gallery.querySelectorAll("[data-gallery-dot]"));
  if (!track || !dots.length) { return; }

  var slides = [].slice.call(track.querySelectorAll(".product__frame"));
  if (!slides.length) { return; }

  function current() {
    // Nearest slide to the centre of the viewport, so a half-swipe
    // still reports the photo the eye is actually on.
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestGap = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var centre = slides[i].offsetLeft + slides[i].offsetWidth / 2;
      var gap = Math.abs(centre - mid);
      if (gap < bestGap) { bestGap = gap; best = i; }
    }
    return best;
  }

  function paint() {
    var active = current();
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle("is-active", i === active);
    }
  }

  var frame = null;
  track.addEventListener("scroll", function () {
    if (frame) { return; }
    frame = window.requestAnimationFrame(function () {
      frame = null;
      paint();
    });
  }, { passive: true });

  dots.forEach(function (dot, i) {
    dot.addEventListener("click", function () {
      var slide = slides[i];
      if (!slide) { return; }
      track.scrollTo({
        left: slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2,
        behavior: "smooth"
      });
    });
  });

  paint();
})();

/* ------------------------------------------------------------------
   3D glove stage.
   The section is tall and its inner viewport pins, so scrolling through
   it turns the glove. Angle and active chapter are both pure functions
   of scroll position — nothing accumulates, so scrolling back up
   unwinds exactly.
   ------------------------------------------------------------------ */
(function () {
  var section = document.querySelector("[data-g3d]");
  if (!section) { return; }

  var viewer = section.querySelector("[data-g3d-viewer]");
  var chapters = [].slice.call(section.querySelectorAll("[data-g3d-chapter]"));
  var hint = section.querySelector("[data-g3d-hint]");
  if (!viewer) { return; }

  var spin = parseFloat(section.dataset.spin) || 540;
  var start = parseFloat(section.dataset.start) || 0;
  var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Without this the section stays one screen tall, which is the correct
  // fallback if the script never runs.
  if (!still) { document.body.classList.add("motion"); }

  function progress() {
    var r = section.getBoundingClientRect();
    var scrollable = r.height - (window.innerHeight || 0);
    if (scrollable <= 0) { return 0; }
    return Math.min(Math.max(-r.top / scrollable, 0), 1);
  }

  var shown = -1;
  function paint() {
    var p = still ? 0 : progress();

    viewer.setAttribute("camera-orbit", (start + p * spin) + "deg 80deg auto");

    if (chapters.length) {
      // Split the scroll evenly between chapters; clamp so the last one
      // holds while the section finishes leaving the screen.
      var i = Math.min(Math.floor(p * chapters.length), chapters.length - 1);
      if (i !== shown) {
        chapters.forEach(function (c, n) { c.classList.toggle("is-on", n === i); });
        shown = i;
      }
    }

    if (hint) { hint.hidden = p > 0.06; }
  }

  var queued = false;
  function onScroll() {
    if (queued) { return; }
    queued = true;
    window.requestAnimationFrame(function () { queued = false; paint(); });
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  viewer.addEventListener("load", paint);
  paint();
})();
